import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import Section from '../../../enums/Sections';
import Status from '../../../enums/Status';
import ChevronRightIcon from '../../../imgs/ChevronRightIcon';
import Button from '../../../UI/Button/Button';
import RenderOn from '../../../UI/RenderOn/RenderOn';
import {getDeliveryOptions} from '../../../v2/actions/deliveryOptionActions';
import {stepForwards} from '../../../v2/actions/uiActions';
import Translation from '../../../v2/lang/Translation';
import {isMobile} from '../../../v2/selectors/DeviceSelectors';
import {
  getIsRedesignPhase1BExperimentCTAVariant,
  isCollapsibleExperiment,
} from '../../../v2/selectors/ExperimentSelectors';
import isStepBeforeDeliverySelector from '../../../v2/selectors/isStepBeforeDeliverySelector';
import makeGetDeliverySpecificKey from '../../../v2/selectors/makeGetDeliverySpecificKey';
import {getSelectedResidentialAddress, getSettings} from '../../../v2/selectors/selectors';
import ProgressButtonContainer from './ProgressButtonContainer';
import isLastStepSelector from '../../../v2/selectors/isLastStepSelector';

const handleClick = (props) => {
  if (props.shouldCallDeliveryOptions) {
    props.getDeliveryOptions();
  }

  props.stepForwards();
};

export function ForwardButton(props) {
  const forwardButton = (
    <Button
      id="ProgressButtons__continueButton"
      fullWidth
      primary
      onClick={() => handleClick(props)}
      data-test="ProgressButtons__forwardButton"
      type="submit"
      iconRight={!props.hideIcon && <ChevronRightIcon rtlSensitive />}
      disabled={props.shouldDisable}
    >
      <Translation>{props.forwardLabel}</Translation>
    </Button>
  );

  return !props.isLastStep && (
    <RenderOn mobile desktop={props.isCollapsibleExperiment}>
      <ProgressButtonContainer
        fullWidth
        sticky={props.sticky}
      >
        {!props.currentStepHasAlternatePrimaryAction && forwardButton}
      </ProgressButtonContainer>
    </RenderOn>
  );
}

ForwardButton.propTypes = {
  currentStepHasAlternatePrimaryAction: PropTypes.bool.isRequired,
  stepForwards: PropTypes.func.isRequired,
  forwardLabel: PropTypes.string.isRequired,
  isCollapsibleExperiment: PropTypes.bool.isRequired,
  isLastStep: PropTypes.bool.isRequired,
  shouldCallDeliveryOptions: PropTypes.bool,
  shouldDisable: PropTypes.bool,
  hideIcon: PropTypes.bool,
  sticky: PropTypes.bool,
};

const mapStateToProps = (state) => {
  const deliveryKey = makeGetDeliverySpecificKey('btn.continue.delivery')(state);

  const forwardLabels = {
    [Section.DELIVERY]: deliveryKey,
    [Section.PAYMENT]: 'btn.continue.text',
  };

  const currentStep = state.ui.checkoutProgressStep;
  const currentSectionIndex = currentStep - 1;
  const isCTAExperiment = getIsRedesignPhase1BExperimentCTAVariant(state);
  const currentStepName = state.ui.sections[currentSectionIndex];
  const deliveryOptionStatus = state.deliveryOption.status;
  const hasPostcode = !!getSelectedResidentialAddress(state)?.postCode;
  const isStepBeforeDelivery = isStepBeforeDeliverySelector(state);

  return {
    isCollapsibleExperiment: isCollapsibleExperiment(state),

    forwardLabel: forwardLabels[state.ui.sections[currentSectionIndex + 1]] || 'btn.continue.text',

    currentStepHasAlternatePrimaryAction: state.ui.sections[currentSectionIndex] === Section.DELIVERY
      && state.deliveryOption.status === Status.NETWORK_ERROR,

    isLastStep: isLastStepSelector(state),
    shouldCallDeliveryOptions: isStepBeforeDelivery && isMobile(state) && deliveryOptionStatus === 'requireData'
      && hasPostcode,
    shouldDisable: currentStepName === 'DELIVERY' && isMobile(state) && deliveryOptionStatus !== 'success',
    hideIcon: getSettings(state)?.hide_cta_button_icons,
    sticky: !getSettings(state)?.remove_sticky_progress_buttons,
  };
};

export default connect(mapStateToProps, {stepForwards, getDeliveryOptions})(ForwardButton);
